<template>
    <div> <!-- Dette er rodtaget -->
    <h1>KonsulentMagnus</h1>
    <nav>
      <!-- Navigationselementer -->
    </nav>
  </div>
</template>

<script>
export default {
  name: 'HovedLinjen'  // Sørg for at navnet er multi-word
}
</script>

<style scoped>
  header {
    background-color: #f8f9fa;
    padding: 1rem;
  }
  
  nav ul {
    display: flex;
    list-style: none;
    padding: 0;
  }
  
  nav ul li {
    margin-right: 20px;
  }
  
  nav ul li a {
    text-decoration: none;
    color: #007bff;
  }
  
  nav ul li a:hover {
    text-decoration: underline;
  }
  </style>